import { useData } from '../services/api';

const useFeatureFlag = (flagKey: string) => (
    useData<boolean>('FeatureFlag', {flagKey})
);

export { useFeatureFlag };